import { TimePeriodEnumDTO } from "@auto-generated/ap-platform/online-appointments";
import { DATEPICKER_FORMATS, MONTH_DATEPICKER_FORMATS, YEAR_DATEPICKER_FORMATS } from "libs/shared/schema/src/lib/global.const";

export class CustomDateFormats {
	value = TimePeriodEnumDTO.WEEK;
  
	get display() {
		switch (this.value) {
			case TimePeriodEnumDTO.YEAR: 
        return YEAR_DATEPICKER_FORMATS.display;
			case TimePeriodEnumDTO.MONTH: 
        return MONTH_DATEPICKER_FORMATS.display;
			default: 
				return DATEPICKER_FORMATS.display;
		}
	}

	get parse() {
		switch (this.value) {
      case TimePeriodEnumDTO.YEAR: 
      return YEAR_DATEPICKER_FORMATS.parse;
    case TimePeriodEnumDTO.MONTH: 
      return MONTH_DATEPICKER_FORMATS.parse;
    default: 
      return DATEPICKER_FORMATS.parse;
		}
	}
}